import Analytics from '../modules/analytics';
import WG from '../modules/wg';

class GdprManager {
    constructor() {
        window.gdprUserCentrics = new WG.GdprUserCentrics();
        this.analytics = new Analytics();

        window.wrike.gdprPopups = {
            userCentrics: new WG.GdprPopup(window.wrike.gdpr.popupStringsUserCentrics)
        };
    }

    init() {
        this.analytics.initRequiredTracking();
        this.hideShortPrivacyPolicyNoticeForUsersFromEu();

        gdprUserCentrics.start(window.wrike.gdprPopups.userCentrics, (consentState) => {
            if (consentState.includes(WG.GdprUserCentrics.ConsentCategories.Functional)) {
                this.analytics.initFunctionalTracking();
                this.analytics.setMarketoCookie(false);
            } else {
                this.analytics.setMarketoCookie(true);
            }

            if (consentState.includes(WG.GdprUserCentrics.ConsentCategories.Advertising)) {
                this.analytics.initAdvertisingTracking();
            }
        });
    }

    hideShortPrivacyPolicyNoticeForUsersFromEu() {
        if (WG.utils.isEuVisitor()) {
            const $shortPrivacyPolicyNotice = $('[data-gdpr="short-notice"]');
            $shortPrivacyPolicyNotice.css('display', 'none');
        }
    }
}

export default GdprManager;



// WEBPACK FOOTER //
// ./assets/js/common/gdpr/gdpr-manager.js